import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { ClinicalCategoryService } from "./clinicalCategory.service";
import { IClinicalCategory } from "./iclinical-category";

@Injectable({
    providedIn: 'root'
})
export class ClinicalCategoryResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private _categoryService: ClinicalCategoryService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, clinicalCategories: IClinicalCategory[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
        };
        return this._categoryService.getCategory(data);
    }
}